import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ActiveCartFacade } from '@spartacus/cart/base/root';
import { I18nModule } from '@spartacus/core';
import { Observable, combineLatest, map } from 'rxjs';
import '../../../models/spartacus-augmented.model';

interface GenAutoShipShipmentDatesViewModel {
  shipmentDates: string[];
  visible: boolean;
}

@Component({
  selector: 'gen-auto-ship-shipment-dates',
  templateUrl: './auto-ship-shipment-dates.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, I18nModule],
})
export class GenAutoShipShipmentDatesComponent {
  readonly initialVisibleDates = 5;
  expanded = false;

  readonly viewModel$: Observable<GenAutoShipShipmentDatesViewModel> = combineLatest([
    this.activeCartFacade.getActive(),
    this.activatedRoute.queryParamMap,
  ]).pipe(
    map(([cart, queryParams]) => ({
      shipmentDates: cart.autoShipShipmentDates ?? [],
      visible: queryParams.get('autoShip') === 'true',
    })),
  );

  constructor(
    private readonly activeCartFacade: ActiveCartFacade,
    private readonly activatedRoute: ActivatedRoute,
  ) { }

  toggleDates(): void {
    this.expanded = !this.expanded;
  }

  trackByShipmentDate(index: number, date: string): string {
    return `${date}-${index}`;
  }
}
